import rootService from "./rootService";

export const delayedService = {
  getDelayed: (filter) => {
    let { startDate, endDate, childuser } = filter;
    return rootService().sctAnalytics.post(
      `/v3/delay?starttime=${startDate}&endtime=${endDate}${
        childuser ? `&childUser=${childuser}` : ``
      }&limit=all`,
      {
        ...filter,
      }
    );
  },
};
